export default ({ request }) => ({
    ecomOrderUploadFileApi(data = {}) {
      return request({
        url: '/ecomorder/ecom/order/upload/file',
        method: 'POST',
        data,
      })
    },
    ecomOrderDelFileApi(data = {}) {
      return request({
        url: '/ecomorder/ecom/order/del/file',
        method: 'POST',
        data,
      })
    },
    ecomOrderFileListApi(data = {}) {
      return request({
        url: '/ecomorder/ecom/order/file/list',
        method: 'POST',
        data,
      })
    },
  })
  